export default __webpack_public_path__ + "static/media/Ultimate_PKG_Layout.8dbe220d.png";